import { Directive, HostListener } from '@angular/core';
import { CheckoutUIService } from '@plys/src/ui/checkout/checkout-u-i.service';

@Directive({
  selector: '[plysGoBack]',
  standalone: true,
  providers: [CheckoutUIService],
})
export class GoBackDirective {
  constructor(private checkoutService: CheckoutUIService) {}

  @HostListener('click', ['$event'])
  handleClick(): void {
    this.checkoutService.goPrev();
  }
}
